'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _close = require('dibs-vg/dist/react/close');

var _close2 = _interopRequireDefault(_close);

var _classnames2 = require('classnames');

var _classnames3 = _interopRequireDefault(_classnames2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ModalCloseButton = function ModalCloseButton(props) {
    var theme = props.theme,
        className = props.className,
        onClick = props.onClick,
        disabled = props.disabled;

    if (!theme) {
        return null;
    }

    var wrapperClass = (0, _classnames3.default)(theme.closeClickableArea, className, (0, _defineProperty3.default)({}, theme.closeButtonDisabled, disabled));

    return _react2.default.createElement(
        'div',
        { className: wrapperClass, onClick: disabled ? function () {} : onClick },
        _react2.default.createElement(
            'div',
            { className: theme.closeIcon },
            _react2.default.createElement(_close2.default, null)
        )
    );
};

exports.default = ModalCloseButton;


//////////////////
// WEBPACK FOOTER
// ./~/dibs-elements/lib/ModalCloseButton/index.js
// module id = 857
// module chunks = 4 5 8 9 14